import { IpLimitationConfigDTO } from "./IpLimitationConfigDTO";
import { TimeLimitationConfigDTO } from "./TimeLimitationConfigDTO";

export class AccessLimitationConfigDTO {
    timeLimitationConfig: TimeLimitationConfigDTO[] = [];
    ipLimitationConfig: IpLimitationConfigDTO[] = [];

    constructor(data?: Partial<AccessLimitationConfigDTO>) {
        Object.assign(this, data);
    }
}
